import React, { useState, useEffect } from 'react';
import useSearchParams from '~/commons/hooks/useSearchParams';
import { useHttpStatus, useComparable } from '../hooks';
import ListTable from './ListTable.jsx';
import ListPagination from './ListPagination.jsx';
import AnimPending from './AnimPending.jsx';
import FormHttpAlert from './FormHttpAlert.jsx';

const ListHttpTable = ({
  api,
  cols,
  skip = 0,
  limit = 20,
  sort,
  filter = {},
  onSelect,
  onRowClick,
  className,
  refresh,
  children,
}) => {
  const [searchParams, setSearchParams] = useSearchParams(null);
  const [selected, setSelected] = useState([]);

  const [query, setQuery] = useState({
    skip,
    limit,
    sort,
  });

  const [
    res,
    req,
    fetched = { rows: [], total: 0 },
  ] = useHttpStatus({
    onSuccess() {
      // clear select
      if (onSelect) {
        setSelected([]);
        onSelect([]);
      }
    },
  });

  const fetch = (q) => {
    const nq = { ...query, ...q };

    setQuery(nq);

    req({
      ...api,
      params: {
        ...nq,
        filter,
      },
    });
  };

  useEffect(() => {
    const curPageValue = searchParams.get('curPage');
    const curSkip = (((curPageValue == null ? 1 : curPageValue) - 1) * 20);

    const sortKey = searchParams.get('sortKey');
    const sortValue = searchParams.get('sortValue');
    if ((sortKey != null) && (sortValue != null)) {
      const s = [];
      s[sortKey] = sortValue;

      fetch({ skip: curSkip, sort: s });
    } else {
      fetch({ skip: curSkip });
    }
  }, [refresh, useComparable({ filter, api })]);

  return (
    <div>
      <FormHttpAlert res={res} />
      <div className="form-row mb-3">
        <div className="col">{children}</div>
        <ListPagination
          {...{
            className: 'col-auto',
            ...query,
            total: fetched.total,
            onChange: fetch,
          }}
        />
      </div>
      <div className="position-relative">
        {res.status === 'pending' && (
          <div className="position-absolute fill">
            <div className="position-absolute fill bg-white opacity-5" />
            <AnimPending />
          </div>
        )}
        <ListTable
          {...{
            className,
            cols,
            rows: fetched.rows,
            onRowClick,
            selected: onSelect ? selected : null,
            onSelect: onSelect ? (s) => {
              setSelected(s);
              onSelect(s.map((i) => (
                fetched.rows[i]
              )));
            } : undefined,
            sort: query.sort,
            onSort: (s) => {
              const keys = Object.keys(s);
              const firstKey = keys[0];
              setSearchParams({ sortKey: firstKey, sortValue: s[firstKey] });
              fetch({ sort: s });
            },
          }}
        />
      </div>
    </div>
  );
};

export default ListHttpTable;
